import {
  GetLimitRequestQuery,
  GetLimitRequestsQuery,
  LimitRequestStatus,
  LimitRequestType,
  LimitTopProductCategory,
} from "../../graphql/generated.ts";
import { toHumanReadable } from "../../utils/string.ts";

export type LimitRequest = GetLimitRequestsQuery["limitRequests"]["data"][0];
export type LimitRequestDetail = GetLimitRequestQuery["limitRequest"];

export const toHumanReadableTopProductCategory = (
  value: LimitTopProductCategory
) => {
  switch (value) {
    case LimitTopProductCategory.TopBronze:
      return "TOP Bronze";
    case LimitTopProductCategory.TopGold:
      return "TOP Gold";
    case LimitTopProductCategory.TopExpress:
      return "TOP Express";
    case LimitTopProductCategory.TopSilver:
      return "TOP Silver";
    default:
      return toHumanReadable(value);
  }
};

export const topProductCategoryOptions = Object.values([
  LimitTopProductCategory.TopBronze,
  LimitTopProductCategory.TopGold,
  LimitTopProductCategory.TopExpress,
  LimitTopProductCategory.TopSilver,
]).map((value) => {
  return { value, label: toHumanReadableTopProductCategory(value) };
});

export const limitRequestTypeOptions = Object.values(LimitRequestType).map(
  (item) => ({
    value: item,
    label: toHumanReadable(item),
  })
);

export const limitRequestLimitTypeOptions = [
  { label: "General", value: LimitRequestType.NewGeneralLimit },
  { label: "Project", value: LimitRequestType.NewProjectLimit },
];

export const generateLimitName = (
  limitRequestType: LimitRequestType | undefined,
  companyName: string | undefined
) => {
  if (!limitRequestType || !companyName) {
    return "";
  }

  if (limitRequestType === LimitRequestType.GeneralRenewal) {
    return `${companyName} - General Limit`;
  }

  if (limitRequestType === LimitRequestType.NewGeneralLimit) {
    return `${companyName} - General Limit`;
  }
  if (limitRequestType === LimitRequestType.TopUpLimit) {
    return `${companyName} - Top Up Limit`;
  }
  if (limitRequestType === LimitRequestType.NewProjectLimit) {
    return `${companyName} - Project Limit`;
  }
  return "";
};

export const tenorOptions = [30, 45, 60, 75, 90].map((t) => ({
  value: String(t),
  label: String(t),
}));

export const pricingApprovedMapping: Record<number, number> = {
  30: 4.0,
  45: 4.75,
  60: 5.5,
  75: 6.25,
  90: 7.0,
};

export const toHumanReadableLimitRequestStatus = (
  value: LimitRequestStatus | null | undefined
) => {
  if (!value) {
    return toHumanReadable(LimitRequestStatus.NewLimitRequest);
  }
  switch (value) {
    case LimitRequestStatus.OlWaitingForCustomer:
      return "Waiting for Customer";
    default:
      return toHumanReadable(value);
  }
};

export const limitRequestStatusOptions = Object.values(LimitRequestStatus).map(
  (item) => ({
    value: item,
    label: toHumanReadableLimitRequestStatus(item),
  })
);
